import {createRouter, createWebHashHistory, useRouter} from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import login from '../views/index/login.vue'
import index from '../views/index/index.vue'
import displayScreen from '../views/displayScreen/displayScreen.vue'
import displayScreenCom from '../views/displayScreen/displayScreenCom.vue'
import displayScreenDemo from '../views/displayScreen/displayScreenDemo.vue'
import AiFavorableComments from '../views/aiComment/AiFavorableComments.vue'
import AiFavorableCommentsDetails from '../views/aiComment/AiFavorableCommentsDetails.vue'
import AiFavorableCommentsDeepLink from '../views/aiComment/AiFavorableCommentsDeepLink.vue'
import userInfo from '../views/index/userInfo.vue'
import store from '../store'
import tools from '../utils/tools'
import {ElMessage} from "element-plus";

//静态路由
const routes = [
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path: '/displayScreen',
        name: 'displayScreen',
        component: displayScreen,
    },
    {
        path: '/displayScreenCom',
        name: 'displayScreenCom',
        component: displayScreenCom,
    },
    {
        path: '/displayScreenDemo',
        name: 'displayScreenDemo',
        component: displayScreenDemo,
    },
    {
        path: '/AiFavorableComments',
        name: 'AiFavorableComments',
        component: AiFavorableComments,
    },
    {
        path: '/AiFavorableCommentsDetails',
        name: 'AiFavorableCommentsDetails',
        component: AiFavorableCommentsDetails,
    },
    {
        path: '/AiFavorableCommentsDeepLink',
        name: 'AiFavorableCommentsDeepLink',
        component: AiFavorableCommentsDeepLink,
    },
    {
        path: '/',
        name: 'index',
        redirect: '/home',
        component: index,
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    title: localStorage.getItem("homepage") ? localStorage.getItem("homepage") : '房间',
                    icon: ''
                },
                component: () => import('@/views/index/home')
            },  //此home用户登录跳转,在组建完路由后会被替换
        ]
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: login,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
});

// 路由加载前
router.beforeEach((to, from, next) => {
    NProgress.configure({showSpinner: false})
    NProgress.start();
    // console.log("访问路径", "@/views" + to.path);

    if (to.name == 'login') {
        next();
    }
    //投屏网页
    else if (to.name == 'displayScreen' || to.name == 'displayScreenCom' || to.name == 'displayScreenDemo') {
        next();
    } else if (to.name == 'AiFavorableComments' || to.name == 'AiFavorableCommentsDetails' || to.name == 'AiFavorableCommentsDeepLink') {
        next();
    }
    //提示开通会员网页
    else if (to.name == 'noticeVip') {
        next();
    }
    //如果token为空且跳转的页面不是登陆页,重定向到登录页
    else if (localStorage.getItem("tokenValue") == '') {
        next({
            name: 'login'
        });
    } else {
        //如果菜单集合为空
        if (store.state.menuList.length == 0) {
            tools.setInfo().then(res => {
                //刷新
                if (from.name == null && to.name != localStorage.getItem('routerName')) {
                    router.push({
                        name: localStorage.getItem('routerName')
                    })
                }
                //判断参数是否有state=jxkj1987,表示是美团授权过来的,跳转到门店
                else if (location.href.indexOf("state=jxkj1987") != -1 && to.name != 'mtShopManage') {
                    next({
                        name: "mtShopManage",
                    });
                }
                //新页面跳转
                else {
                    next();
                }
                //设置tab列
                tools.settingTabList(to);
            }).catch(err => {
                console.log("路由信息错误", err);
                //获取信息出错,清空token,回到登录
                localStorage.setItem("tokenValue", "");
                next({
                    name: 'login'
                });
            })
        } else {
            next();
            //设置tab列
            tools.settingTabList(to);
        }
    }
});

// 路由加载后
router.afterEach(() => {
    NProgress.done()
});

export default router
